import React, { useEffect, useRef } from 'react';
import './CustomModal.css'; // custom css file
import { getIconSrc } from '../../helpers/getImgSrc';

const CustomModal = ({ isOpen, setIsOpen, title, body, footer }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsOpen]);

  return (
    <>
      {isOpen ? (
        <div className="custom-modal-overlay">
          <div className="custom-modal" ref={modalRef}>
            <div className="custom-modal-header">
              <span className='title'>{title}</span>
              <div className="close-button" onClick={() => { setIsOpen(false) }}>
                <img src={getIconSrc("cross", 'svg')} alt="" />
              </div>
            </div>
            <div className="custom-modal-body">
              {body}
            </div>
            <div className="custom-modal-footer">
              {footer}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default CustomModal;
